import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { TRANSLATIONS_KZ } from "./kz";
import { TRANSLATIONS_RU } from "./ru";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            ru: {
                translation: TRANSLATIONS_RU
            },
            kz: {
                translation: TRANSLATIONS_KZ
            }
        }
    });


export default i18n